import * as types from './types';
import { createCoverageReducers } from '../../../common/coverage/reducers';
import { RdcDeviceCoverageRecord } from '../../../../records';

const { initialState, reducer } = createCoverageReducers({
  types,
  CoverageRecord: RdcDeviceCoverageRecord,
});

export default reducer;
export { initialState };
